import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)



// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
};


const routes = [
    // 重定向
    {
        path: '/',
        redirect: '/home'
    },
    // 登陆页面
    {
        path: '/login/:isAutoLogin?',
        name: 'login',
        props: true,
        component: () => import('../views/login/index.vue')
    },
    // OA审批
    {
        path: '/approvalcenter/index',
        name: 'approvalcenter',
        meta: { title: 'OA审批' },
        component: () => import('../views/home/approvalcenter/index.vue')
    },
    // 发起审批
    {
        path: '/approvalcenter/initiateapprove/:pkey/:id/:instanceId?',
        name: 'initiateapprove',
        meta: { title: '发起审批' },
        props: true,
        component: () => import('../views/home/approvalcenter/initiateapprove.vue')
    },
    // 公告
    {
        path: '/notice/index',
        name: 'notice',
        meta: { title: '公告' },
        component: () => import('../views/home/notice/index.vue')
    },
    // 公告详情
    {
        path: '/notice/detail/:id?',
        name: 'detail',
        props: true,
        meta: { title: '公告详情' },
        component: () => import('../views/home/notice/detail.vue')
    },

    // main主页面，布局页
    {
        path: '/home',
        name: 'home',
        meta: { title: '首页' },
        //redirect:'/manage/index',//进入主页面home页，直接展示首页的内容
        component: () => import('../views/home/index.vue'),
        children: [
            // 通讯录
            {
                path: '/work/addressbook',
                name: 'addressbook',
                meta: { title: '通讯录' },
                component: () => import('../views/home/work/addressbook.vue')
            },
            // 组织架构管理
            {
                path: '/manage/index',
                name: 'manageindex',
                meta: { title: '组织架构管理' },
                component: () => import('../views/home/manage/index.vue')
            },
            // OA审批管理
            {
                path: '/oamanage/index',
                name: 'oamanageindex',
                meta: { title: 'OA审批管理' },
                component: () => import('../views/home/oamanage/index.vue')
            },
            // 云盘文件
            {
                path: '/fileupload/index',
                name: 'fileuploadindex',
                meta: { title: '云盘文件' },
                component: () => import('../views/home/fileupload/index.vue')
            },
            // 公告管理
            {
                path: '/notice/noticelist',
                name: 'noticelist',
                meta: { title: '公告管理' },
                component: () => import('../views/home/notice/noticelist.vue')
            },
            {
                path: '/metamanage/index',
                name: 'metamanageindex',
                meta: { title: '元数据管理' },
                component: () => import('../views/home/metamanage/index.vue')
            },
            {
                path: '/attendance/index',
                name: 'attendanceindex',
                meta: { title: '考勤管理' },
                component: () => import('../views/home/attendance/index.vue'),
                redirect: '/attendance/index/overview',
                children: [
                    {
                        path: 'overview',
                        component: () => import('../views/home/attendance/AttendanceOverview.vue'),
                        name: 'AttendanceOverview',
                        meta: {
                            title: '考勤概览',
                            isChildRoute: true,
                            parentRoute: '/attendance/index',
                            parentTitle: '考勤管理'
                        }
                    },
                    {
                        path: 'group/:operate?',
                        component: () => import('../views/home/attendance/AttendanceGroup.vue'),
                        name: 'AttendanceGroup',
                        props: true,
                        meta: {
                            title: '考勤组管理',
                            isChildRoute: true,
                            parentRoute: '/attendance/index',
                            parentTitle: '考勤管理'
                        }
                    },
                    {
                        path: 'shift/:operate?',
                        component: () => import('../views/home/attendance/ShiftManagement.vue'),
                        name: 'ShiftManagement',
                        props: true,
                        meta: {
                            title: '班次管理',
                            isChildRoute: true,
                            parentRoute: '/attendance/index',
                            parentTitle: '考勤管理'
                        }
                    },
                    {
                        path: 'stat',
                        component: () => import('../views/home/attendance/TableStatistics.vue'),
                        name: 'TableStatistics',
                        meta: {
                            title: '考勤统计',
                            isChildRoute: true,
                            parentRoute: '/attendance/index',
                            parentTitle: '考勤管理'
                        }
                    },
                    {
                        path: 'analysis',
                        component: () => import('../views/home/attendance/AttendanceAnalysis.vue'),
                        name: 'AttendanceAnalysis',
                        meta: {
                            title: '假勤分析',
                            isChildRoute: true,
                            parentRoute: '/attendance/index',
                            parentTitle: '考勤管理'
                        },
                    },
                    {
                        path: 'holidayRules',
                        component: () => import('../views/home/attendance/HolidayRules.vue'),
                        name: 'HolidayRules',
                        meta: {
                            title: '假期规则',
                            isChildRoute: true,
                            parentRoute: '/attendance/index',
                            parentTitle: '考勤管理'
                        },
                    },
                    {
                        path: 'holidayQuery',
                        component: () => import('../views/home/attendance/HolidayQuery.vue'),
                        name: 'HolidayQuery',
                        meta: {
                            title: '员工假期余额',
                            isChildRoute: true,
                            parentRoute: '/attendance/index',
                            parentTitle: '考勤管理'
                        },
                    }
                ]
            },
            // 3.业务管理
            // 3.1项目管理
            {
                path: '/project/new',
                name: 'projectNew',
                meta: { title: '项目管理' },
                component: () => import('../views/home/projectmanage/project.vue')
            },
            {
                path: '/project/detail/:id',
                name: 'ProjectDetail',
                props: true,
                component: () => import('@/views/home/projectmanage/projectDetail.vue'),
                meta: {
                    title: '项目详情',
                    dynamicTab: true, // 标记为动态标签页
                    parentRoute: '/project/new' // 指定父级路由，用于菜单高亮
                }
            },
            {
                path: '/project/statistics',
                name: 'projectStatistics',
                meta: { title: '项目工时统计' },
                component: () => import('../views/home/projectmanage/workHoursStatistics.vue')
            },
            {
                path: '/project/deal',
                name: 'projectDeal',
                meta: { title: '项目待办' },
                component: () => import('../views/home/projectmanage/projectDeal.vue')
            },
            {
                path: '/project/person',
                name: 'projectPerson',
                meta: { title: '研发人员管理' },
                component: () => import('../views/home/projectmanage/person.vue')
            },
            // 3.2知识产权管理
            {
                path: '/knowledge/index',
                name: 'knowledge',
                meta: { title: '知识产权管理' },
                component: () => import('../views/home/business/knowledge.vue')
            },
            // 3.3费用管理
            {
                path: '/cost/index',
                name: 'cost',
                meta: { title: '费用管理' },
                component: () => import('../views/home/business/cost.vue')
            },
            // 3.4资产管理
            {
                path: '/assets/index',
                name: 'assets',
                meta: { title: '资产管理' },
                component: () => import('../views/home/business/assetsmanage.vue')
            },
            // 3.5知识产权统计
            {
                path: '/knowledge/statistics',
                name: 'knowledgeStatistics',
                meta: { title: '知识产权统计' },
                component: () => import('../views/home/business/knowledgestatistics.vue')
            },
            // 3.6任务管理
            {
                path: '/taskmanage/index',
                name: 'taskmanage',
                meta: { title: '任务管理' },
                component: () => import('../views/home/taskmanage/index.vue')
            },
            {
                path: '/testmanage/plan',
                name: 'plan',
                meta: { title: '测试计划' },
                component: () => import('../views/home/testmanage/plan.vue')
            },
            {
                path: '/testmanage/bugmanage',
                name: 'bugmanage',
                meta: { title: 'BUG管理' },
                component: () => import('../views/home/testmanage/bugmanage.vue')
            },
            {
                path: '/testmanage/case',
                name: 'case',
                meta: { title: '用例库' },
                component: () => import('../views/home/testmanage/casestore.vue')
            },
            // 供应商管理
            {
                path: '/hardware/suppliermanage',
                name: 'suppliermanage',
                meta: { title: '供应商管理' },
                component: () => import('../views/home/hardware/suppliermanage.vue')
            },
            // 硬件设备管理
            {
                path: '/hardware/devicemanage',
                name: 'devicemanage',
                meta: { title: '硬件设备管理' },
                component: () => import('../views/home/hardware/devicemanage.vue')
            },
            // 绩效管理
            {
                path: '/perf/performance',
                name: 'performance',
                meta: { title: '个人绩效' },
                component: () => import('../views/home/perf/performance.vue')
            },
            // 绩效管理
            {
                path: '/perf/perfApproval',
                name: 'perfApproval',
                meta: { title: '绩效评审' },
                component: () => import('../views/home/perf/perfApproval.vue')
            },
            // 2.系统管理
            // 2.1用户管理
            {
                path: '/system/user',
                name: 'user',
                meta: { title: '用户管理' },
                component: () => import('../views/home/system/user.vue')
            },
            // 2.2角色管理
            {
                path: '/system/role',
                name: 'role',
                meta: { title: '角色管理' },
                component: () => import('../views/home/system/role.vue')
            },
            // 2.3组织管理
            {
                path: '/system/department',
                name: 'department',
                meta: { title: '组织管理' },
                component: () => import('../views/home/system/department.vue')
            },
            {
                path: '/system/person',
                name: 'person',
                meta: { title: '成员管理' },
                component: () => import('../views/home/system/person.vue')
            },
            {
                path: '/system/function',
                name: 'function',
                meta: { title: '菜单管理' },
                component: () => import('../views/home/system/function.vue')
            },
            // 2.4日志管理
            {
                path: '/system/log',
                name: 'log',
                meta: { title: '日志管理' },
                component: () => import('../views/home/system/log.vue')
            },
        ]
    }
]

const router = new VueRouter({
    // mode: 'history',
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
